"use strict";

/**
 * @classdesc
 * Abstrakte Mess-Interaktion.
 *
 * @class
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.module.GCMeasure
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCMeasure} options.instance Modul-Instanz
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}] Karten-Instanz
 */
gc.gis.module.GCMeasureImpl = function( options )
{
	gc.gis.GCWrappable.call( this );

	this.module = options.instance;
	this.map    = options.map || gc.gis.iface.map;
};
gc.gis.module.GCMeasureImpl.prototype = Object.create( gc.gis.GCWrappable.prototype );

/**
 * Interaktion (de-)aktivieren.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {boolean} active
 */
gc.gis.module.GCMeasureImpl.prototype.setActive = gc.gis.abstractMethod;

/**
 * Messergebnisse zurücksetzen.
 *
 * @public
 * @abstract
 * @method
 */
gc.gis.module.GCMeasureImpl.prototype.clear = gc.gis.abstractMethod;

/**
 * Ein Segment auf der Karte highlighten.
 *
 * @public
 * @abstract
 * @method
 *
 * @param {*} feature Feature-Implementierung
 */
gc.gis.module.GCMeasureImpl.prototype.highlightSegment = gc.gis.abstractMethod;

/**
 * Feature-Highlighting deaktivieren.
 *
 * @public
 * @abstract
 * @method
 */
gc.gis.module.GCMeasureImpl.prototype.resetHighlighting = gc.gis.abstractMethod;

